import React,{useContext,useEffect,useState} from 'react';
import { useHistory } from "react-router-dom";
import {AuthContext} from '../context/AuthContext'
import {GeneralesContext} from '../context/GeneralesContext'
import Cargando from '../layout/Cargando';
import moment from 'moment';
import axios from 'axios';
import qs from 'qs';
import Panel from './ParosFallasPanel'
import {makeStyles} from '@material-ui/core'
import io from "socket.io-client";
import {toast} from "react-toastify";
import {llamaApiContext,ErrorContext ,llamadaApiToken,ErrorGeneral} from '../funciones/ClienteAxios';
const colorBarra="#51ad32";//claro
const colorBarraHover="#73bd5b";// tenue
const colorBackBarra="#d6e6d1";//mas tenue

const ENDPOINT = "https://teleferico-socket.daduva.mx:5000";

const estilos = makeStyles(theme=>({
    miroot:{
        
        scrollbarColor: colorBarra+" "+colorBarraHover,//"#51ad32 #c4e6f2",
        "&::-webkit-scrollbar, & *::-webkit-scrollbar": {
          backgroundColor: colorBackBarra,
        },
        "&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb": {
          borderRadius: 8,
          backgroundColor: colorBarra,
          minHeight: 24,
          border: "3px solid "+colorBarra,
        },
        "&::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus": {
          backgroundColor: colorBackBarra,
        },
        "&::-webkit-scrollbar-thumb:active, & *::-webkit-scrollbar-thumb:active": {
          backgroundColor: colorBackBarra,
        },
        "&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover": {
          backgroundColor: colorBarraHover,
        },
        "&::-webkit-scrollbar-corner, & *::-webkit-scrollbar-corner": {
          backgroundColor: colorBackBarra,
        },
    },    

}))
const ParosFllasinicio = () => {
    const misclases = estilos()
    let history = useHistory();
    const source = axios.CancelToken.source();     
    const socket = io(ENDPOINT,  {transports: ['websocket']});//se conecta     
    const {usuario,guardarUsuario}= useContext(AuthContext);
    const [totales, setTotales] = useState([]);    
    const [espera, setEspera] = useState(false);    
    const {generales,guardarGenerales}= useContext(GeneralesContext);      
    const [fInicio, setFinicio] = useState(moment(new Date()).format("YYYY/MM/DD "));
    const [fFinal, setFFinal] = useState(moment(new Date()).format("YYYY/MM/DD "));    
    const [buscar, setBuscar] = useState(true);
    const [Bucle, setBucle] = useState(0);       
    //const [lastNotif,setLastNotif] = useState(0)
    const [newSocketParo,setNewSocketParo] = useState([])
    const [turnoBit, setTurnoBit] = useState([]);
    useEffect(()=>{                                          

		
	    veriSesion();	
        return ()=> {
            source.cancel();
        }			
	},[buscar]); 
    
    useEffect(()=>{    
    
        socket.on("/Paro/New/Emit/", data => {                
            const info=JSON.parse(data)
           //console.log(newSocketParo,parseInt(info.paroId ),info);
            if ( newSocketParo.length !==0 || newSocketParo?.paroId !== parseInt(info.paroId ))  
            {                
                const fch= moment(info.Fecha).format("YYYY-MM-DD hh:mm a")
                const Fchfin = new Date(moment(fFinal).format("YYYY-MM-DD"))
                const hoy = new Date(moment(fInicio).format("YYYY-MM-DD"))
                const fchReg = new Date(moment(info.freg).format("YYYY-MM-DD"))    
                 if (Fchfin.getTime() >= fchReg.getTime() && hoy.getTime() <= fchReg.getTime() ) 
                {
                    const mensaje=`Se registro un nuevo paro, ${fch}` 
                    toast.info(mensaje, {
                        pauseOnFocusLoss: false,
                        toastId: `socket-BitParoNew${info.Key}`
                    })
                    setTotales({...totales, totalEficiente: info.totalEficiente, 
                        totalParo: info.totalParo, paroTotalHora: info.paroTotalHora, 
                        paroRegistro: info.paroRegistro })
                    setNewSocketParo(info)
                }
            }            
        });

        socket.on("/Paro/Edit/Emit/", data => {                
            const info=JSON.parse(data)
            //console.log(info);            
                                 
            if (""+info.terminal === ""+Bucle ) 
            {   const fch2 = new Date(moment(fFinal).format("YYYY-MM-DD"))
                const hoy = new Date(moment(fInicio).format("YYYY-MM-DD"))
                const fchReg = new Date(moment(info.freg).format("YYYY-MM-DD"))             
               // console.log(info);
                
                if (fch2.getTime() >= fchReg.getTime() && hoy.getTime() <= fchReg.getTime() ) 
                {
                    const mensaje=`Se edito el  Paro/Falla ${info.paroId } ` 
                    toast.info(mensaje, {
                        pauseOnFocusLoss: false,
                        toastId: `socket-bitParoEdit${info.Key}`
                    })
                    setTotales({...totales, totalEficiente: info.totalEficiente, 
                        totalParo: info.totalParo, paroTotalHora: info.paroTotalHora, 
                        paroRegistro: info.paroRegistro })
                                        
                    /* if (hoy.getTime()<=fchReg.getDate() ) {                        
                    } */
                    setNewSocketParo(info)                        
                }                          
            }                                                
        });

        /* */

        socket.on("/Bitacora/Cierre/Usuario/Emit/", data => {                
            const info=JSON.parse(data)
            //console.log(info, ""+totales.bitacoraId, ""+info.bitacoraId);
            if (""+totales?.bitacoraId === ""+info.bitacoraId) 
            {                                      
               const fch= moment(info.Emite).format("YYYY-MM-DD hh:mm a")                                             
                const mensaje=`Se edito el # de usuarios, ${fch}` 
                toast.info(mensaje, {
                    pauseOnFocusLoss: false,
                    toastId: `socket-notifi${info.Key}`
                })  
               setTotales({...totales,UserCobro: info.usuarios.keyTp0, UserExento: info.usuarios.keyTpExe})                                                                                          
            }
        });

       socket.on("/Bitacora/Cierre/Emit/", data => {                
            const info=JSON.parse(data)
        
            //console.log(info, Bucle);                     
            if (""+totales?.bitacoraId === ""+info.Body.bitacora) 
            {   const fch= moment(info.Emite).format("YYYY-MM-DD hh:mm a")                                             
                const mensaje=`Se edito el  Cierre, ${fch}` 
                toast.info(mensaje, {
                    pauseOnFocusLoss: false,
                    toastId: `socket-bitCierr${info.Key}`
                })
                setTotales({...totales, Cabina: info.Body.cabina, 
                    HFin: info.Body.fechaTermino, Pinza: info.Body.pinza,         
                    incidencia: info.Body.incidencia, recorrido: info.recorrido, 
                    vuelta: info.vuelta, })                                          
            }                                                
        }); 

        socket.on("/Bitacora/Apertura/Emit/", data => {                
            const info=JSON.parse(data)
            //console.log(parseInt(info.paroId ),info, Bucle);
            
            if (""+totales?.bitacoraId === ""+info.Body.bitacora) 
            {   const fch= moment(info.Emite).format("YYYY-MM-DD hh:mm a")                                             
                const mensaje=`Se edito la  Apertura, ${fch}` 
                toast.info(mensaje, {
                    pauseOnFocusLoss: false,
                    toastId: `socket-bitApert${info.Key}`
                })
                const auxHorometro = Number(info.Body.Horometro )
                //console.log(info,auxHorometro);                     
                setTotales({...totales, Cabina: info.Body.cabina, 
                    TiempoOpera: `${info.Body.operacion}:00`, HIni: `${info.Body.fechaInicio}:00`, 
                    
                    Horometro: auxHorometro, })
                                          
            }                                                
        });

        socket.on("/Bitacora/Turno/Emit/", data => {                
            const info=JSON.parse(data)
            
            //console.log(info, Bucle, turnoBit);                     
            if ((""+info.terminal === ""+Bucle ) && (""+totales?.bitacoraId === ""+info.Body.Bit1)) 
            {   const fch= moment(info.Emite).format("YYYY-MM-DD hh:mm a")                                             
                const mensaje=`Se editaron los Turnos, ${fch}` 
                toast.info(mensaje, {
                    pauseOnFocusLoss: false,
                    toastId: `socket-bitTurno${info.Key}`
                })
                const editBits={...turnoBit.bitacoras[0], Turno1:info.Body.Bit1Campo1,
                    Turno2 :info.Body.Bit1Campo2}
                let nvoArr2=[]
                nvoArr2[0]=editBits
                
                //console.log(nvoArr2);
                    
                setTurnoBit({...turnoBit, bitacoras:nvoArr2 })
                                          
            }                                                
        });

        return () => socket.disconnect();   
    })

   

    const veriSesion =  () => {            
        let auxTer=0;
        const usu= localStorage.getItem('UsuarioNom');
        let usuId= localStorage.getItem('UsuId');
        const nvl= localStorage.getItem('Tipo');
        const auxTerminal= localStorage.getItem('UsuTerminal')?parseInt(localStorage.getItem('UsuTerminal')):0;            
        const auxUbi= JSON.parse(localStorage.getItem('LisUbicOrd'));
        
        if (auxUbi === null ||auxUbi === undefined ) 
        {   llamarUbicacionOrd()    
        }                
        if(usu==null|| usuId===null)
        {   guardarUsuario([])				
            guardarGenerales([])    
            localStorage.clear();            	             
            history.push("/")	                	
        }
        else{
            if (usuario.length===0) 
            {
                guardarUsuario({...usuario,Nombre:usu,nivel:nvl,usrId:usuId});                                                      
            }
            if(generales.length==0)
            {
                guardarGenerales({...generales,Terminal:auxTerminal})   
                setBucle(auxTerminal)     
                auxTer=auxTerminal
            }
            else
            {   if(Bucle==0)
                {   auxTer=auxTerminal
                    setBucle(auxTerminal)     
                }
                else
                {   if(auxTerminal !=Bucle)
                    {   auxTer=Bucle
                    }    
                    else
                    {   setBucle(auxTerminal)     
                        auxTer=auxTerminal
                    }
                }                                       
            }
            guardarGenerales({...generales,Titulo:'Bitácora'})      
            llamaParoTotal(auxTer);       
            const auxUbi= localStorage.getItem('LisUbic');
            if (auxUbi===null) {
                llamaUbicacion()       
            }                
        }
    }
    
    const llamaUbicacion = () => {              
        let data = qs.stringify({                
            idDispositivo:'89y7gttvjhj98h'
        });
        let url = "/lugar-ubicacion-list";
        function respuesta(auxiliar) 
        {
            if (auxiliar ) 
            {   localStorage.setItem('LisUbic', JSON.stringify(auxiliar));   
            }               
        }      
        llamaApiContext(data, url,respuesta,ErrorContext,setEspera,history,source,guardarUsuario,guardarGenerales);            
    };  
    const llamarUbicacionOrd = () => {      
        let data = qs.stringify({
            tipo:'ORD',
            idDispositivo:'89y7gttvjhj98h'
        });
        let url = "/lugar-ubicacion-list-1_1";
        function respuestaListInterv(auxiliar) {
          if (auxiliar[0].Id!==-1) 
          {                
            localStorage.setItem('LisUbicOrd', JSON.stringify(auxiliar));                                    
          }                    
        }
  
        llamadaApiToken(data, url,respuestaListInterv,ErrorGeneral,history,source);
    };  

    const llamaParoTotal = (auxTer) => {     
        setTotales([])         
        let data = qs.stringify({
            terminal:auxTer ,
            fechaIni:fInicio+'00:00:00' ,
            fechaFin:fFinal+'23:59:59',    
            idDispositivo:'89y7gttvjhj98h'
        });
        let url = "/parofalla-total";
        function respuesta(auxiliar) 
        {
            if (auxiliar &&auxiliar[0].Id!= -1 ) 
            {   setTotales(auxiliar[0])                    
            }               
        } 

        llamaApiContext(data, url,respuesta,ErrorContext,setEspera,history,source,guardarUsuario,guardarGenerales);            
    }; 

    const contenido = totales.length !== 0 && !espera ?
                    <Panel totales={totales}  finicio={fInicio}  setFinicio={setFinicio}  
                        fFinal={fFinal} setFFinal={setFFinal} buscar={buscar} setBuscar={setBuscar}  
                        Bucle={Bucle} setBucle={setBucle}  usuarioContxt={usuario}  
                        newSocketParo={newSocketParo} turnoBit={turnoBit} setTurnoBit={setTurnoBit}           
                    /> 
                    :<Cargando/>
    return (
        <div className={misclases.miroot} >
            {contenido}
        </div>
    );
}
 
export default ParosFllasinicio;